import { useMutation, useQueryClient } from '@tanstack/react-query';
import { newsKeys } from 'src/modules/home/hooks/newsKeys';
import { NewsAPI } from 'src/services/api/newsApi';

const updateAsRead = async (guid: string) => {
  const newsApi = new NewsAPI();
  await newsApi.ReadNews(guid);
};

export const useMarkAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: newsKeys.all });
    },
  });
};
